import React from 'react';
import { AuthValidation } from '@src/features/customers/auth/legacy/styled/AuthStyled';
import { useFieldError } from '@src/features/customers/hooks/useFieldError';
import { InputArea, InputAttribute, InputLabel } from '@src/features/customers/auth/legacy/styled/InputStyled';
import { FormInputInputType } from '@src/core/buyerApiClient';

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'autoComplete' | 'name'> {
  name: string;
  type?: FormInputInputType;
  label?: string;
  errorContext?: string;
  issetError?: boolean;
  autoComplete?: boolean;
  maxlength?: number;
}

/** @deprecated Use `<BaseInput></BaseInput>` instead */
const Input = ({
  name,
  type = 'text',
  label,
  errorContext,
  required,
  autoComplete = true,
  maxlength,
  onChange,
  onBlur,
  ...rest
}: InputProps) => {
  const errorMessage = useFieldError(errorContext, name);

  return (
    <InputArea>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <InputAttribute
        errorContext={errorContext}
        label={label}
        name={name}
        id={name}
        type={type}
        $issetError={!!errorMessage}
        required={required}
        autoComplete={autoComplete ? 'on' : name}
        maxLength={maxlength}
        onChange={onChange}
        onBlur={onBlur}
        {...rest}
      />
      <AuthValidation>{errorMessage}</AuthValidation>
    </InputArea>
  );
};

export default Input;
